<div *ngIf="isLoadingResults" class="wrapperLoader">
    <div class="loader">
    </div>
</div>

<button type="submit" (click)="ImportDirectServiceRates()" class="btn btn-add">Import</button>